export enum MeasureUnit {
    Imperial = 1,
    Metric = 2
}